require('angular').module('wowApp.common')
    .factory('HeartbeatService', ['$interval', '$rootScope', 'Restangular', 'ShopperService', 'config', '$window', require('./heartbeat.service')])
    .run([
        'HeartbeatService', function (heartbeatService) {
            heartbeatService.startContextHeartbeat();
        },
    ]);



// WEBPACK FOOTER //
// ./src/common/heartbeat/index.js